<div class="col px-lg-5 px-2">
	
	<app-nav-gestion-donnees
		class="row py-5"
		[addable]="isAddable"
		(addEvent)="openModalAjout()"
		[isImportable]="isImportable"
		(importingEvent)="uploader.click()"
		[isExportable]="isExportable"
		(exportingEvent)="exportEmployeurs()"
	></app-nav-gestion-donnees>

	<input hidden type="file" #uploader (change)="importEmployeurs($event)" />

	<div class="row my-3">
		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="pageHasChanged($event)"
				previousLabel="Précédent"
				nextLabel="Suivant"
			>
			</pagination-controls>
		</div>
		<div class="row">
			<div class="col-lg-4 col-12 ps-lg-5 ms-lg-auto">
				<div class="input-group">
					<span class="input-group-text bg-transparent"
						><i class="bi bi-search" aria-hidden="true"></i
					></span>
					<input
						type="text"
						class="form-control border-start-0"
						placeholder="Nom(s), prénom(s), adresse"
						[(ngModel)]="searchedInput"
						(keyup)="onKeyUp()"
					/>
				</div>
			</div>
		</div>
		<div *ngIf="!isMobile" class="row mt-3">
			<div class="col-4">
				<span class="hand-cursor fw-bold limitLineSpan" (click)="sortChange('lastName')"
					>Nom de la structure
				</span>
			</div>
			<div class="col-3">
				<span class="ps-1 hand-cursor fw-bold limitLineSpan">
					Type de structure
				</span>
			</div>
			<div class="col-4">
				<span
					class="ps-1 hand-cursor fw-bold limitLineSpan"
					(click)="sortChange('address.label')"
					>Adresse
				</span>
			</div>
			<div class="col-1"></div>
		</div>

		<div class="mt-4" *ngIf="isListingLoading">
			<app-loading></app-loading>
		</div>

		<div *ngIf="!isListingLoading" class="mt-4">
			<div
				*ngFor="
					let employeur of employeurs
						| paginate
							: {
									itemsPerPage: itemsPerPage,
									currentPage: currentPage,
									totalItems: totalItems
							  }
						| orderBy : sortType : sortOrder
				"
				class="row my-1 pt-3 pb-1 rounded rounded-3 bg-light"
			>
				<span class="col-lg-4 col-12 limitLineSpan">
					<span *ngIf="isMobile" class="fw-bold">Nom de la structure:</span>
					{{ employeur?.nomStructure }}
				</span>
				<div class="col-lg-3">
					<div class="d-flex">
						<span class="flex-grow-1 limitLineSpan">
							<span *ngIf="isMobile" class="fw-bold">Type de strucuture :</span>
							{{ employeur?.typeEntreprise?.name }}
						</span>
					</div>
				</div>
				<div class="col-lg-4">
					<div class="d-flex">
						<span class="flex-grow-1 limitLineSpan">
							<span *ngIf="isMobile" class="fw-bold">Adresse :</span>
							{{ employeur?.addressStructure?.label }}
						</span>
					</div>
				</div>
				<div class="col-12 col-lg-1 d-flex p-lg-0">
					<i
						[routerLink]="['/gestion/employeurs', employeur.id]"
						profile="button"
						class="fs-4 bi bi-caret-right-fill mb-1 me-2"
						aria-hidden="true"
					></i>
				</div>
			
			</div>
		</div>
		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="pageHasChanged($event)"
				previousLabel="Précédent"
				nextLabel="Suivant"
			>
			</pagination-controls>
		</div>
	</div>
</div>
